import { GoogleIconColor } from "@/components/icons/google-icon-color";
import { Button } from "@/components/ui/button";
import { useScript } from "@/lib/hooks/use-script";
import React from "react";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

declare global {
  interface Window {
    google: {
      accounts: {
        oauth2: {
          initTokenClient: (config: any) => {
            requestAccessToken: () => void;
          };
        };
      };
    };
  }
}

export const SignInWithGoogleButton = ({
  onSuccess,
  onError,
  loginHint,
}: {
  onSuccess: (token: string) => void;
  onError: (message: string) => void;
  loginHint?: string;
}) => {
  const scriptStatus = useScript("https://accounts.google.com/gsi/client");
  const [tokenClient, setTokenClient] = React.useState<any>(null);

  React.useEffect(() => {
    if (scriptStatus !== "ready") return;

    // Initialize the popup flow
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: GOOGLE_CLIENT_ID,
      scope: "openid email profile",
      prompt: "consent",
      login_hint: loginHint,
      callback: (response: any) => {
        if (response.error && response.error_description) {
          onError(response.error_description);
        }
        if (response.access_token) {
          onSuccess(response.access_token);
        }
      },
    });

    setTokenClient(client);
  }, [scriptStatus]);

  const handleGoogleSignIn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (tokenClient) {
      tokenClient.requestAccessToken();
    }
  };

  return (
    <Button
      name="oauthGoogle"
      id="oauthGoogle"
      type="button"
      onClick={handleGoogleSignIn}
      className="relative"
      disabled={!tokenClient}
    >
      <GoogleIconColor className="absolute left-2 top-1/2 size-4 -translate-y-1/2" />
      Sign in with Google
    </Button>
  );
};
